<script setup lang="ts">
/** A key hint (`F2`, `⌫`). `aria-hidden`, so an item's accessible name stays just its label. */
import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"

const props = defineProps<{ class?: HTMLAttributes["class"] }>()
</script>

<template>
  <span aria-hidden="true" :class="cn('ml-auto text-[10px] tracking-widest text-muted-foreground', props.class)">
    <slot />
  </span>
</template>
